<template>
  <div class="publish-detail" ref="publishDetailRef">
    <JumpHeader />
    <div class="publish-img">
      <img src="~@/assets/image/publish_detail_bg.png" alt="" />
    </div>
    <div class="publish-info">
      <van-image
        width="100px"
        height="100px"
        fit="contain"
        class="avatar"
        round
        :src="publishInfo.logo"
      />
      <div class="num-wrapper">
        <div class="num-item">
          <span>获赞</span>
          <span class="num">{{ filterNum(numInfo.praiseCount) }}</span>
        </div>
        <div class="num-item">
          <span>关注</span>
          <span class="num">{{ numInfo.careCount }}</span>
        </div>
        <div class="num-item">
          <span>发布咨询</span>
          <span class="num">{{ filterNum(numInfo.videoCount) }}</span>
        </div>
      </div>
    </div>
    <div class="publish-name">
      <div class="name">{{ publishInfo.name }}</div>
      <div class="focus" @click="failToast">关注</div>
    </div>
    <div class="verify">
      <img src="~@/assets/image/verify.png" alt="" />
      <span>广州市广播电视台认证账号</span>
    </div>
    <div class="intro">
      {{ publishInfo.intro ? publishInfo.intro : "作品主要是作者对文学创作的一些看法" }}
    </div>
    <van-tabs sticky v-model="tabsActive" line-width="70px">
      <van-tab :title="`视频${filterNum(numInfo.videoCount)}`">
        <van-list
          v-model="videoLoad.loading"
          :finished="videoLoad.finished"
          finished-text="已经到底了"
          @load="videoOnLoad"
          class="video-list"
        >
          <div class="video-container">
            <VideoItem
              class="video-item-class"
              :item="item"
              v-for="item in videoList"
              :key="item.id"
              @click="toVideoDetail(item)"
            />
          </div>
        </van-list>
      </van-tab>
      <van-tab title="文章">
        <van-list
          v-model="articleLoad.loading"
          :finished="articleLoad.finished"
          finished-text="已经到底了"
          @load="articleOnLoad"
          class="article-list"
        >
          <div class="article-container">
            <ArticleItem
              :item="item"
              v-for="item in articleList"
              :key="item.id"
              @click="toArticleDetail(item)"
            />
          </div>
        </van-list>
      </van-tab>
      <van-tab title="直播">
        <van-list
          v-model="livingLoad.loading"
          :finished="livingLoad.finished"
          finished-text="已经到底了"
          @load="livingOnLoad"
          class="living-list"
        >
          <LivingItem
            :item="item"
            v-for="item in livingList"
            :key="item.id"
            @click="toLiveDetail(item)"
          />
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { Toast } from "vant";
import VideoItem from "@/components/VideoItem";
import LivingItem from "@/components/LivingItem";
import ArticleItem from "@/components/ArticleItem";
import JumpHeader from "@/components/Base/JumpHeader";
import { getCount, getVideo, queryPublishArticles, getLiveRoom } from "@/http/api";

export default {
  name: "PublishDetail",
  components: {
    VideoItem,
    ArticleItem,
    LivingItem,
    JumpHeader,
  },
  data() {
    return {
      numInfo: {
        careCount: 0,
        liveRoomCount: 0,
        newsCount: 0,
        praiseCount: 0,
        videoCount: 0,
      },
      id: null,
      videoList: [],
      tabsActive: 0,
      livingList: [],
      articleList: [],
      publishInfo: {},
      videoPageNum: 1,
      videoLoad: {
        loading: false,
        finished: false,
      },
      articleLoad: {
        loading: false,
        finished: false,
        pageNum: 1,
      },
      livingLoad: {
        loading: false,
        finished: false,
        pageNum: 1,
      },
    };
  },
  mounted() {
    if(window.location.href.indexOf("share.gztv.com")){
      window.location.href=window.location.href.replace("share.gztv.com","app.gztv.com");
    }
    this.id = this.$route.query.id;
    this.queryDetail();
    this.getVideoList(1);
  },
  methods: {
    failToast() {
      Toast.fail("请先下载APP");
    },
    async queryDetail() {
      const { data } = await getCount({
        id: this.id,
      });
      console.log(data);
      this.numInfo = {
        careCount: data.careCount,
        liveRoomCount: data.liveRoomCount,
        newsCount: data.newsCount,
        praiseCount: data.praiseCount,
        videoCount: data.videoCount,
      };
      this.publishInfo = data.publishInfo;
      document.title = this.publishInfo.name ? this.publishInfo.name : "花城+";
      this.$nextTick(() => {
        this.wxShare();
      });
    },
    async getVideoList(pageNum) {
      this.videoLoad.loading = true;
      const { data } = await getVideo({
        id: this.id,
        pageNum: pageNum,
        pageSize: 10,
      });
      this.videoLoad.loading = false;
      if (this.videoPageNum >= data.pages) {
        this.videoLoad.finished = true;
      }
      this.videoList = [...this.videoList, ...data.records];
    },
    async getArticleList() {
      this.articleLoad.loading = true;
      const { data } = await queryPublishArticles({
        pageNumber: this.articleLoad.pageNum,
        pageSize: 10,
        param: {
          huaChengId: this.id,
        },
      });
      this.articleLoad.loading = false;
      if (this.articleLoad.pageNum >= data.pages) {
        this.articleLoad.finished = true;
      }
      this.articleList = [...this.articleList, ...data.records];
    },
    async getLivingList() {
      this.livingLoad.loading = true;
      const { data } = await getLiveRoom({
        id: this.id,
        pageNum: this.livingLoad.pageNum,
        pageSize: 10,
      });
      this.livingLoad.loading = false;
      if (this.livingLoad.pageNum >= data.pages) {
        this.livingLoad.finished = true;
      }
      this.livingList = [...this.livingList, ...data.records];
    },
    videoOnLoad() {
      this.videoPageNum++;
      this.getVideoList(this.videoPageNum);
    },
    articleOnLoad() {
      this.articleLoad.pageNum++;
      this.getArticleList();
    },
    livingOnLoad() {
      this.livingLoad.pageNum++;
      this.getLivingList();
    },
    filterNum(val) {
      if (val && val > 10000) {
        return `${(val / 10000).toFixed(2)}w`;
      }
      return val;
    },
    toVideoDetail(item) {
      this.$router.push({
        name: "videoDetail",
        query: {
          id: item.id,
        },
      });
    },
    toArticleDetail(item) {
      this.$router.push({
        name: "articleDetail",
        query: {
          id: item.articleId,
        },
      });
    },
    toLiveDetail(item) {
      this.$router.push({
        name: "liveDetail",
        query: {
          id: item.id,
        },
      });
    },
    wxShare() {
      const _publishInfo = this.publishInfo;
      wxSdk.getJSSDK({
        title: _publishInfo.name,
        desc: _publishInfo.intro ? _publishInfo.intro : _publishInfo.name,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/publishDetail?id=${_publishInfo.paramValue}`,
        img: _publishInfo.img,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.publish-img {
  width: 100%;
  height: 180px;

  & > img {
    width: 100%;
    height: 100%;
  }
}

.publish-info {
  display: flex;
  position: relative;
  flex-direction: row-reverse;

  .num-wrapper {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .num-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 60px;

      & > span {
        display: inline-block;
        color: #00000073;
        font-size: 12px;
        margin-bottom: 3px;
      }

      .num {
        color: #000000d9;
        font-size: 16px;
      }
    }
  }

  .avatar {
    position: absolute;
    left: 15px;
    transform: translateY(-50%);
  }
}

.publish-name {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;

  .name {
    color: #000000d9;
    font-size: 18px;
  }

  .focus {
    color: #d55555;
    border: 1px solid #d55555;
    width: 40px;
    height: 20px;
    font-size: 12px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.verify {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;

  margin-top: 5px;

  & > img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }

  & > span {
    font-size: 12px;
    color: #00000073;
  }
}

.intro {
  margin-top: 5px;
  box-sizing: border-box;
  padding: 0 15px;
  color: #000000a6;
  font-size: 12px;
}

.video-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .video-container {
    display: flex;
    flex-wrap: wrap;

    .video-item-class {
      width: 33%;
      /* min-width: 33%; */
      min-width: 33vw;
      max-width: 200px;
      height: 200px;
      margin-right: 0.5%;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}

@media screen and (min-width: 580px) {
  .video-item-class {
    min-width: 185px !important;
    width: 185px !important;
  }
}

.article-list,
.living-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
